<div class="layout-row layout-align-start-center recommendation-group-item">
  <div class="flex">{{ recommendationGroup.name }}</div>
  <div class="flex">{{ recommendationGroup.total }}</div>
  <bringoz-button class="flex-5"
                  type="tertiary"
                  size="xl">
    <bringoz-icon fill="#aaa" classSize="xl" iconName="arrow-right"></bringoz-icon>
  </bringoz-button>
</div>

